import React, { useState, useEffect, useContext, useRef, useMemo, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Checkbox, Col, Divider, Form, Popover, Progress, Row, Spin, Switch, Tooltip, message, notification, Modal, Input, Button } from 'antd';
import { useLocation, useNavigate }from "react-router-dom"; 
import { ExclamationCircleOutlined, InfoCircleFilled } from '@ant-design/icons';
import API from '@api/api.js';
import { AppContext, channel } from '@utils/AppContext';
import styles from './loggedHead.module.scss'
import CountUp from 'react-countup';
import eventBus from '@utils/eventBus';
import PSAIModal from "@PSAIComponents/PSAIModal";
import { EventStreamContentType, fetchEventSource } from '@microsoft/fetch-event-source';
import Utils from '@utils/utils'

function LoggedHead (props) {
    const location = useLocation();
    const navigate = useNavigate();
    const payChildRef = useRef(null);
    const couponChildRef = useRef()
    const { globalUser, globalBalance, setHasToken, setGlobaluser, } = useContext(AppContext);
    const [open, setOpen] = useState(false)
    const [powerBalance, setPowerBalance] = useState(globalBalance)
    const [notificationApi, contextHolder] = notification.useNotification();

    useEffect(() => {
        setPowerBalance(globalBalance)
    }, [globalBalance])

    // 用来检查是否有虹豆/套餐到期需要提醒
    useEffect(() => {
        eventBus.emit('updateOrderList')
    }, [])
    
    // 多账号登录时更新账号信息
    useEffect(() => {
        eventBus.emit('updateUserInfo')
        eventBus.emit('updatePower')
        eventBus.emit('updateActivityInfo')
    }, [location])

    const goPerson = () => {
        window.open("/home/homemain/personalCenter", "_blank");
        // navigate("/home/homemain/personalCenter")
        setOpen(false)
    }

    const goBack = () => {
        if (location.pathname == "/home/homemain/requirement") {
            eventBus.emit('requirementForm:edited', () => {
                API.logout({}).then(res => {
                    navigate('/')
                    setGlobaluser()
                    localStorage.removeItem('token')
                    sessionStorage.removeItem('taskCache_model')
                    sessionStorage.removeItem('taskCache_dressform')
                    sessionStorage.removeItem('taskCache_clothes')
                    sessionStorage.removeItem('taskCache_commodity')
                    sessionStorage.removeItem('taskCache_tryonVideo')
                    sessionStorage.removeItem('taskCache_commodityVideo')
                    localStorage.removeItem('channel')
                    setHasToken(false)
                    setOpen(false)
                }).catch((error) => {
                    navigate('/')
                    localStorage.removeItem('token')
                    sessionStorage.removeItem('taskCache_model')
                    sessionStorage.removeItem('taskCache_dressform')
                    sessionStorage.removeItem('taskCache_clothes')
                    sessionStorage.removeItem('taskCache_commodity')
                    sessionStorage.removeItem('taskCache_tryonVideo')
                    sessionStorage.removeItem('taskCache_commodityVideo')
                    localStorage.removeItem('channel')
                    setHasToken(false)
                })
            })
            return
        }
        API.logout({}).then(res => {
            navigate('/')
            setGlobaluser()
            localStorage.removeItem('token')
            sessionStorage.removeItem('taskCache_model')
            sessionStorage.removeItem('taskCache_dressform')
            sessionStorage.removeItem('taskCache_clothes')
            sessionStorage.removeItem('taskCache_commodity')
            sessionStorage.removeItem('taskCache_tryonVideo')
            sessionStorage.removeItem('taskCache_commodityVideo')
            localStorage.removeItem('channel')
            setHasToken(false)
            setOpen(false)
        }).catch((error) => {
            navigate('/')
            localStorage.removeItem('token')
            sessionStorage.removeItem('taskCache_model')
            sessionStorage.removeItem('taskCache_dressform')
            sessionStorage.removeItem('taskCache_clothes')
            sessionStorage.removeItem('taskCache_commodity')
            sessionStorage.removeItem('taskCache_tryonVideo')
            sessionStorage.removeItem('taskCache_commodityVideo')
            localStorage.removeItem('channel')
            setHasToken(false)
        })
    }
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if(newOpen) {
            eventBus.emit('updateUserInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }
    }

    const notifyConfigRef = useRef()
    const [settingOpen, setSettingOpen] = useState(false)
    const goSetting = useCallback(() => {
        console.log('goSetting')
        setSettingOpen(true)
        setOpen(false)
    }, [])
    const handleNofitifyConfigOk = useCallback(() => {
        notifyConfigRef.current?.onSubmit()
    }, [notifyConfigRef])
    const handleNotify = useCallback(({
        title,
        description,
        icon,
        id,
    }) => {
        notificationApi.info({
            title: title,
            icon: icon,
            description: description,
            placement: 'topRight',
            duration: false,
            onClose: () => {
                console.log('close', id)
                API.markNotifyRead({recordIds: [id]})
            },
        })
    }, [])
    // 获取未读通知
    useEffect(() => {
        API.getNotifyUnread().then(res => {
            console.log(res)
            if (res?.code != 0) throw new Error(res.message)
            const data = res.data
            for (let item of data) {
                let description, icon
                if (item.title == "以下订单已完成制作，请及时验收") {
                    icon = <InfoCircleFilled style={{color: "#1677ff"}} />
                    description = (
                        <ul style={{listStyle:"disc",listStylePosition:"inside"}}>
                            <li><a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault()
                                    window.location.href = `/home/homemain/masterDeliver?${new URLSearchParams({version: item.content}).toString()}`
                                    // API.markNotifyRead({recordIds: [item.id]})
                                }}
                            >{item.content}</a></li>
                        </ul>
                    )
                } else if (item.title == "您有新的结算单，请及时核对确认") {
                    icon = <InfoCircleFilled style={{color: "#FF8C3F"}} />
                    description = (
                        <div>
                            <span>结算单编号：</span>
                            <a href="#" onClick={(e) => {
                                e.preventDefault()
                                window.location.href = `/home/homemain/personalCenter?tab=confirm`
                                // API.markNotifyRead({recordIds: [item.id]})
                            }}>{item.content}</a>
                        </div>
                    )
                }
                handleNotify({
                    title: item.title,
                    description: description,
                    icon: icon,
                    id: item.id,
                })
            }
        }).catch(err => {
            console.error(err)
            message.warning(err.message)
        })
    }, [])
    // 获取通知流数据
    useEffect(() => {
        const ctrl = new AbortController()
        fetchEventSource(API.notifyStreamURL, {
            method: "GET",
            openWhenHidden: true, //页面退至后台保持连接
            headers: {
                'Content-Type': 'application/json',
                'Ps-Auth-Token': localStorage.getItem('token')
            },
            signal: ctrl.signal,
            async onopen (response) {
                console.log('onopen', response, response.headers.get('content-type'))
                if (response.ok && (response.headers.get('content-type') || "").includes(EventStreamContentType)) {
                    return
                } else if (response.status == 401) {
                    throw new Error('Unauthorized')
                } else if (response.status >= 400 && response.status < 500 && response.status !== 429) {
                    throw new Error('FatalError')
                } else {
                    throw new Error('RetriableError')
                }
            },
            onmessage (msg) {
                try {
                    const data = JSON.parse(msg.data)
                    console.log('data', data)
                    if (data.eventType == "connect") return
                    if (data.channelType == "web_popup") {
                        let description, icon
                        if (data.eventType == "acceptance") {
                            icon = <InfoCircleFilled style={{color: "#1677ff"}} />
                            description = (
                                <ul style={{listStyle:"disc",listStylePosition:"inside"}}>
                                    <li><a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            window.location.href = `/home/homemain/masterDeliver?${new URLSearchParams({version: data.content}).toString()}`
                                            // API.markNotifyRead({recordIds: [data.id]})
                                        }}
                                    >{data.content}</a></li>
                                </ul>
                            )
                        } else if (data.eventType == "settlement") {
                            icon = <InfoCircleFilled style={{color: "#FF8C3F"}} />
                            description = (
                                <div>
                                    <span>结算单编号：</span>
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault()
                                        window.location.href = `/home/homemain/personalCenter?tab=confirm`
                                        // API.markNotifyRead({recordIds: [data.id]})
                                    }}>{data.content}</a>
                                </div>
                            )
                        }
                        handleNotify({
                            title: data.title,
                            description: description,
                            icon: icon,
                            id: data.id,
                        })
                    }
                } catch (err) {
                    console.error(err)
                }
            },
            onclose () {
                console.log('onclose')
            },
            onerror (err) {
                if (err.message == "Unauthorized") {
                    localStorage.removeItem('token')
                    eventBus.emit('tokenExpired', {pathname: location.pathname})
                    throw err
                } else {
                    console.error(err)
                    return 5000
                }
            }
        })
        return () => {
            ctrl && ctrl.abort()
        }
    }, [])

    const content = (
        <div className='popover_box'>
            {
                globalUser?<div>
                    <div className={styles.popover_box_}>
                        <div className={styles.popover_box_top}>
                            <img className={styles.img1} src={require('@assets/images/icon_Avatar.png')} alt="" />
                            <ul>
                                <li className={styles.li1}>{globalUser?.mobile ? globalUser?.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : globalUser?.email}</li>
                            </ul>
                        </div>
                        <p className={styles.balance_p}><span>剩余金额</span><span>￥ {globalBalance}</span></p>
                        {/* <Progress percent={Math.ceil(globalUser?.membership?.balance/ globalUser?.membership?.amount) * 100} showInfo={false} /> */}
                      
                                {/* <p className={styles.coupon_p} onClick={openCouponClick}>我的优惠券</p> */}
                        <p className={styles.center_p} onClick={goPerson}>个人中心</p>
                        <p className={styles.center_p} onClick={goSetting}>消息设置</p>
                        <Divider style={{margin: 0}} />
                        <p className={styles.logout_p} onClick={goBack}>退出登录</p>
                    </div>
                </div>: null
            }
        </div>
    );

    const [startBalance, setStartBalance] = useState(0)
    const [endBalance, setEndBalance] = useState(0)
    const endBalanceRef = useRef(0)

    useEffect(() => {
        endBalanceRef.current = powerBalance
        setEndBalance(powerBalance)
    }, [powerBalance])

    const countUpEnd = () => {
        setStartBalance(endBalanceRef.current)
    }

    return (
        <>
        {contextHolder}
        <div className={styles.LoggedHead}>
            <div></div>
            <div style={{display: 'flex'}}>
                <div className={styles.LoggedHead_power}>
                    <span className={styles.LoggedHead_powerAmount}>{<CountUp start={startBalance} end={endBalance} decimals={2} separator=","  onEnd={countUpEnd}/>}</span>
                </div>
                {
                    <Popover
                        classNames={{root: 'person_popover'}}
                        placement="bottomRight"
                        content={content}
                        trigger="click"
                        onOpenChange={handleOpenChange}
                        open={open}
                    >
                        <img className={styles.LoggedHead_photo} onClick={() => setOpen(true)} src={require('@assets/images/icon_Avatar.png')} alt="" />
                    </Popover>
                }
            </div>
        </div>
        <PSAIModal
            title="消息设置"
            maxWidth={410}
            destroyOnClose={true}
            open={settingOpen}
            onCancel={() => setSettingOpen(false)}
            onOk={handleNofitifyConfigOk}
        >
            <NotificationSetting ref={notifyConfigRef} onClose={() => setSettingOpen(false)} />
        </PSAIModal>
        </>
    )
}

export default LoggedHead

var NotificationSetting = forwardRef((props, ref) => {
    const [notifyEnabled, setNotifyEnabled] = useState(false)
    const [webPopupEvents, setWebPopupEvents] = useState([])
    const [smsEvents, setSmsEvents] = useState([])
    const [wechatEvents, setWechatEvents] = useState([])
    const [smsTarget, setSmsTarget] = useState()
    const [wechatTarget, setWechatTarget] = useState()
    const [force, updateForce] = useState()

    useImperativeHandle(ref, () => ({
        onSubmit: async () => {
            const data = {
                "notifyEnabled": notifyEnabled,
                "channels": [{
                    "channelType": "web_popup",
                    "enable": true,
                    "events": [
                        { "eventType": "acceptance", "subscribed": webPopupEvents.includes("acceptance") },
                        { "eventType": "settlement", "subscribed": webPopupEvents.includes("settlement") }
                    ]
                }, {
                    "channelType": "sms",
                    "enable": true,
                    "events": [
                        { "eventType": "acceptance", "subscribed": smsEvents.includes("acceptance") },
                        { "eventType": "settlement", "subscribed": smsEvents.includes("settlement") }
                    ]
                }, {
                    "channelType": "wechat",
                    "enable": true,
                    "events": [
                        { "eventType": "acceptance", "subscribed": wechatEvents.includes("acceptance") },
                        { "eventType": "settlement", "subscribed": wechatEvents.includes("settlement") }
                    ]
                }]
            }
            return API.updateNotifyConfig(data).then(res => {
                console.log(res)
                if (res?.code != 0) throw new Error(res.message)
                message.success("更新成功")
                props.onClose()
            }).catch(err => {
                console.error(err)
                message.warning(err.message)
            })
        }
    }))

    useEffect(() => {
        API.getNotifyConfig().then(res => { 
            if (res.code != 0) throw new Error(res.message)
            const data = res.data
            setNotifyEnabled(data.notifyEnabled)
            if (Boolean) {
                const webPopup = data.channels.find(item => item.channelType == "web_popup")
                const events = webPopup?.events || []
                setWebPopupEvents(events.filter(item => item.subscribed).map(item => item.eventType))
            }
            if (Boolean) {
                const sms = data.channels.find(item => item.channelType == "sms")
                const events = sms?.events || []
                setSmsEvents(events.filter(item => item.subscribed).map(item => item.eventType))
                setSmsTarget(sms?.target || "")
            }
            if (Boolean) {
                const wechat = data.channels.find(item => item.channelType == "wechat")
                const events = wechat?.events || []
                setWechatEvents(events.filter(item => item.subscribed).map(item => item.eventType))
                setWechatTarget(wechat?.target || "")
            }            
        })
    }, [force])

    // 默认关闭，打开总开关后显示具体配置
    // 打开总开关后默认站内弹窗消息全勾选
    const handleNotifyEnabledChange = useCallback((checked) => {
        setNotifyEnabled(checked)
        if (checked) {
            setWebPopupEvents(["acceptance", "settlement"])
        }
    }, [])

    return (
        <div style={{width: 346, margin: "40px auto 15px"}}>
            <Row gutter={16} style={{marginBottom: 20}}>
                <Col span={6} style={{fontSize: 16}}>消息通知</Col>
                <Col span={18}>
                    <Switch checked={notifyEnabled} onChange={handleNotifyEnabledChange} />
                </Col>
            </Row>
            <Row gutter={16} style={{marginBottom: 16}}>
                <Col span={6}>站内通知</Col>
                <Col span={18}>
                    <Checkbox.Group disabled={!notifyEnabled} value={webPopupEvents} onChange={setWebPopupEvents}>
                        <Checkbox value="acceptance">验收</Checkbox>
                        <Checkbox value="settlement">结算</Checkbox>
                    </Checkbox.Group>
                </Col>
            </Row>
            <Row gutter={16} style={{marginBottom: 16}}>
                <Col span={6}>短信通知</Col>
                <Col span={18}>
                    <MessageNotification disabled={!notifyEnabled} value={smsEvents} onChange={setSmsEvents} target={smsTarget} updateForce={updateForce} />
                </Col>
            </Row>
            <Row gutter={16} style={{marginBottom: 16}}>
                <Col span={6}>公众号通知</Col>
                <Col span={18}>
                    <PublicNotification disabled={!notifyEnabled} value={wechatEvents} onChange={setWechatEvents} target={wechatTarget} updateForce={updateForce} />
                </Col>
            </Row>
        </div>
    )
})

function MessageNotification ({disabled, value, onChange, target, updateForce}) {
    const [open, setOpen] = useState(false)
    const [smsTarget, setSmsTarget] = useState(target)
    useEffect(() => {
        setSmsTarget(target)
    }, [target])
    const handleBind = useCallback(() => {
        if (disabled) return
        setOpen(true)
    }, [disabled])

    return (
        <div>
            <Checkbox.Group disabled={disabled} value={value} onChange={onChange}>
                <Checkbox value="acceptance">验收</Checkbox>
                <Checkbox value="settlement">结算</Checkbox>
            </Checkbox.Group>
            <div style={{marginTop:8,display:"flex",justifyContent:"flex-start",alignItems:"center", gap: 20}}>
                <span style={{fontSize:12, color:"rgba(0, 0, 0, 0.5)"}}>接收手机号：{smsTarget}</span>
                <span style={{fontSize:14, color: disabled ? "rgba(0, 0, 0, 0.2)" : "#006EFF", cursor: disabled ? "not-allowed" : "pointer"}} onClick={handleBind}>更换</span>
            </div>
            <BindMobileModal
                mobile={smsTarget}
                open={open}
                closeFunc={mobile => {
                    setOpen(false)
                    if (mobile) setSmsTarget(mobile)
                }} />
        </div>
    )
}

function PublicNotification ({disabled, value, onChange, target, updateForce}) {
    const [open, setOpen] = useState(false)
    const [wechatTarget, setWechatTarget] = useState(target)
    useEffect(() => {
        setWechatTarget(target)
    }, [target])
    const handleBind = useCallback(() => {
        if (disabled) return
        if (wechatTarget) {
            PSAIModal.confirm({
                title: "确认解绑公众号吗？",
                okText: "确认",
                onOk: () => {
                    return API.unbindWechat().then(res => {
                        if (res?.code != 0) throw new Error(res?.message || "解绑失败")
                        message.success('解绑成功')
                        setWechatTarget()
                        updateForce({})
                    }).catch(err => {
                        console.error(err)
                        message.warning(err.message)
                    })
                }
            })
        } else {
            setOpen(true)
        }
    }, [disabled, wechatTarget, updateForce])

    return (
        <>
        <div style={{display:"flex",justifyContent:"flex-start",alignItems:"center", gap: 20}}>
        {
            wechatTarget ?
            <Checkbox.Group disabled={disabled} value={value} onChange={onChange}>
                <Checkbox value="acceptance">验收</Checkbox>
                <Checkbox value="settlement">结算</Checkbox>
            </Checkbox.Group> : null
        }
            <span
                style={{fontSize:14, color: disabled ? "rgba(0, 0, 0, 0.2)" : "#006EFF", cursor: disabled ? "not-allowed" : "pointer"}}
                onClick={handleBind}
            >
            {wechatTarget ? "解绑" : "绑定"}
            </span>
        </div>
        <PSAIModal
            title="绑定公众号"
            maxWidth={410}
            destroyOnClose={true}
            open={open}
            onCancel={() => setOpen(false)}
            footer={null}
        >
            <BindQrCode onClose={() => {
                setOpen(false)
                updateForce({})
            }} />
        </PSAIModal>
        </>
    )
}

function BindQrCode ({onClose}) {
    const [loading, setLoading] = useState(false)
    const [wechatUrl, setWechatUrl] = useState()
    const isMounted = useRef(true)
    
    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const loopWechatStatus = useCallback(() => {
        API.getBindStatus().then(res => {
            if (res.code == 0) {
                if (!res.data) {
                    if (!isMounted.current) return
                    setTimeout(() => {
                        loopWechatStatus()
                    }, 1000)
                } else {
                    setTimeout(() => {
                        message.success('绑定成功')
                        onClose()
                    }, 500)
                }
            } else {
                if (!isMounted.current) return
                setTimeout(() => {
                    loopWechatStatus()
                }, 1000)
            }
        }).catch(err => {
            console.error(err)
            message.warning(err.message)
        })
    }, [])
    const getWechatQrcode = useCallback(() => {
        setLoading(true)
        API.getUserBindQrCode().then(res => {
            if (res.code != 0) throw new Error(res.message)
            setWechatUrl(res.data)
        }).catch(err => {
            console.error(err)
            message.warning(err.message)
        }).finally(() => {
            setLoading(false)
        })
    }, [])
    useEffect(() => {
        getWechatQrcode()
        loopWechatStatus()
    }, [getWechatQrcode, loopWechatStatus])

    return (
        <div className={styles.BindQrCode}>
            <Spin spinning={loading}>
                <div style={{width:232,height:232}}>
                { wechatUrl && <img src={wechatUrl} alt="" /> }
                </div>
            </Spin>
            <div className={styles.BindQrCodeTips}>
                <span>微信扫码关注公众号完成绑定</span>
            </div>
        </div>
    )
}

function BindMobileModal (props) {
    const [open, setOpen] = useState(false)
    const [mobile, setMobile] = useState()
    const [intervalId, setIntervalId] = useState()
    const [waitCode, setWaitCode] = useState(false)
    const [countdown, setCountdown] = useState(60)
    const countdownRef = useRef(60)
    const [verifyCode, setVerifyCode] = useState() // 验证码
    const [step, setStep] = useState(1) // 步骤。1-验证身份 2-更换手机号
    const [okDisabled, setOkDisabled] = useState(true)
    const [okLoading, setOkLoading] = useState(false)
    const [isMobileError, setIsMobileError] = useState(false)

    useEffect(() => {
        return () => {
            intervalId && clearInterval(intervalId)
        }
    }, [])

    useEffect(() => {
        if (step == 1) {
            setOkDisabled(!verifyCode)
        } else {
            setOkDisabled(!verifyCode || !mobile || isMobileError)
        }
    }, [step, verifyCode])

    useEffect(() => {
        reset()
        setMobile(props.mobile || '')
        if(props.mobile || '') {
            setStep(1)
        } else {
            setStep(2)
        }
        setOpen(props.open)
    }, [props.open, props.mobile])

    const reset = () => {
        setWaitCode(false)
        setCountdown(60)
        countdownRef.current = 60
        setVerifyCode('')
        setOkLoading(false)
        setIsMobileError(false)
        intervalId && clearInterval(intervalId)
    }

    const mobileBlur = () => {
        setIsMobileError(!Utils.validateContact(mobile))
    }

    const sendCodeDisabled = useMemo(() => {
        return !Utils.validateContact(mobile)
    }, [mobile])

    const codeClick = () => {
        if (!waitCode) {
            setWaitCode(true)
            API.userSendCode({
                mobile: mobile
            }).then((res) => {
                if(res.code == 0) {
                    message.success('发送成功！')
                    let id = setInterval(() => {
                        countdownRef.current -= 1
                        setCountdown(countdownRef.current)
                        if (countdownRef.current === 0) {
                            clearInterval(id)
                            setWaitCode(false)
                            countdownRef.current = 60
                        }
                    }, 1000)
                    setIntervalId(id)
                } else {
                    setWaitCode(false)
                    message.error(res.message)
                }
            })
        }               
    }

    const onOk = () => {
        if (step == 1) {
            setOkLoading(true)
            API.checkVerifyCode({
                mobile: mobile,
                verifyCode: verifyCode
            }).then(res => {
                if(res.code == 0) {
                    message.success('已确认身份，请更换手机号')
                    reset()
                    setStep(2)
                    setMobile('')
                } else {
                    setVerifyCode('')
                    message.error(res.message)
                }                
            }).finally(() => {
                setOkLoading(false)
            })
        } else {
            setOkLoading(true)
            API.rebindSmsMobile({
                mobile: mobile,
                verifyCode: verifyCode
            }).then(res => {
                if(res.code == 0) {
                    message.success('接收手机号已更新')
                    props.closeFunc(mobile)
                } else {
                    setVerifyCode('')
                    message.error(res.message)
                }                
            }).finally(() => {
                setOkLoading(false)
            })
        }
    }

    return (
        <PSAIModal
            title={props.mobile ? '更换接收手机号': '绑定接收手机号'}
            maxWidth={520}
            okText={ step == 1 ? '下一步' : '确认' }
            open={open}
            okButtonProps={{ disabled: okDisabled, loading: okLoading }}
            onCancel={() => props.closeFunc()}
            onOk={onOk}
        >
            <div className={styles.mobileModal_body}>
                {props.mobile && <p className={styles.mobileModal_subtitle}>仅更换接收消息的手机号，不更换当前账号绑定的手机号</p>}
                <div className={styles.mobileModal_form}>
                    
                    {
                        step == 1 ? 
                            <p>当前手机号为{mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}，请先输入验证码以确认身份</p> :
                            <div className={styles.mobileModal_mobile}>
                                <label htmlFor="mobile-new" className={styles.mobileModal_new_label}>绑定手机号</label>
                                <Input
                                    id='mobile-new'
                                    className={styles.mobileModal_new_input}
                                    size='large'
                                    value={mobile}
                                    placeholder="请输入需要绑定的手机号"
                                    onBlur={mobileBlur}
                                    onChange={(e) => setMobile(e.target.value)}
                                    prefix={<img style={{width: 16}} src={require('@assets/images/icon_phone.png')} alt="" />}
                                />
                            </div>
                    }
                    
                    <div className={styles.mobileModal_code}>
                        <label htmlFor="mobile-code" className={styles.mobileModal_code_label}>手机验证码</label>
                        <Input
                            id='mobile-code'
                            size='large'
                            maxLength={6}
                            value={verifyCode}
                            placeholder="请输入验证码"
                            onChange={(e) => setVerifyCode(e.target.value)}
                            prefix={<img style={{width: 16}} src={require('@assets/images/icon_Validation.png')} alt="" />}
                        />
                        <Button disabled={sendCodeDisabled} size='large' onClick={codeClick}>{waitCode ? `${countdown}秒` : '验证码'}</Button>
                    </div>
                    <p className={styles.err_text} style={{opacity: isMobileError? 1: 0}}><ExclamationCircleOutlined /> 您输入的手机号错误</p>
                </div>
            </div>
        </PSAIModal>
    )
}